var _g, _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddPatient(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 118,
    viewBox: "0 0 118 118",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_91_4193)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 58.8724,
    cy: 54.8724,
    r: 54.8724,
    fill: "#ADB84E"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.3609 26.9677C45.6809 30.6448 43.6599 35.5276 43.6599 40.742C43.6599 51.472 52.4075 60.1827 63.1459 60.1827C68.3341 60.1827 73.2206 58.1633 76.9006 54.4861C80.5806 50.8089 82.6016 45.9262 82.6016 40.7118C82.6016 29.9818 73.8541 21.241 63.1157 21.241C57.9275 21.241 53.0409 23.2604 49.3307 26.9375L49.3609 26.9677ZM77.4436 40.7118C77.4436 44.5397 75.9656 48.1264 73.2508 50.8391C70.536 53.5517 66.9465 55.0286 63.1459 55.0286C55.2429 55.0286 48.818 48.6087 48.818 40.7118C48.818 36.884 50.296 33.2972 53.0108 30.5846C55.7255 27.8719 59.315 26.395 63.1459 26.395C71.0488 26.395 77.4737 32.815 77.4737 40.7118H77.4436Z",
    fill: "#F9F9F9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M76.5577 60.8779C75.6521 60.0755 74.3084 60.0182 73.3444 60.7346C73.2276 60.8206 62.1566 68.988 51.8451 60.7346C50.9104 59.9895 49.5374 59.9895 48.6319 60.7919C48.2229 61.1358 38.5833 69.5612 38.3496 86.0394C38.3496 86.6985 38.6125 87.329 39.0799 87.7875C39.5473 88.2461 40.1899 88.504 40.8618 88.504H83.6559C84.9997 88.504 86.1097 87.4436 86.1389 86.1254C86.1389 85.4663 86.5771 69.8478 76.5577 60.8492V60.8779ZM43.4615 83.6322C44.221 74.2897 48.369 68.4149 50.5598 65.893C59.5568 71.7679 69.2257 68.988 74.5421 65.8357C79.6248 71.4813 80.7933 79.6201 81.0854 83.6322H43.4615Z",
    fill: "#F9F9F9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.794 66.6122V45.0122H29.93V66.6122H24.794ZM16.298 58.2122V53.4122H38.426V58.2122H16.298Z",
    fill: "#F9F9F9"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_91_4193",
    x: 0,
    y: 0,
    width: 117.745,
    height: 117.745,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_91_4193"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_91_4193",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddPatient);
export default __webpack_public_path__ + "static/media/addPatient.3f5a27d080b3586473233bd086b8c781.svg";
export { ForwardRef as ReactComponent };